import { PatientListService } from "./common/patient-list";

export class OrganizationService extends PatientListService<any> {
  constructor() {
    super("organization");
  }

  getSchedule({ organizationId, startDate, endDate }, opts) {
    return this.api
      .get(
        `/${organizationId}/schedule`,
        {
          params: {
            startDate,
            endDate,
          },
        },
        // @ts-expect-error TODO(bug): axios.get takes 2 arguments, `opts` is silently ignored
        opts
      )
      .then((res) => res.data);
  }

  /* Team */

  getTeam({ organizationId }) {
    return this.api.get(`/${organizationId}/team`).then((res) => res.data);
  }

  getTeamMember(id, userId) {
    return this.api.get(`/${id}/team/${userId}`).then((res) => res.data);
  }

  getStatistics(id, { periodStartDate, periodEndDate }) {
    return this.api
      .get(`${id}/statistics`, {
        params: {
          periodStartDate,
          periodEndDate,
        },
      })
      .then((res) => res.data);
  }

  requestToJoin({ organizationId, role }) {
    return this.api
      .post(`/${organizationId}/request-to-join`, null, {
        params: { role },
      })
      .then((res) => res.data);
  }

  inviteToJoin({ organizationId, userId, message, role }) {
    return this.api
      .post(`/${organizationId}/invite-to-join`, { userId, message, role })
      .then((res) => res.data);
  }

  inviteNewToJoin({ organizationId, email, message, role }) {
    return this.api
      .post(`/${organizationId}/invite-new-to-join`, { email, message, role })
      .then((res) => res.data);
  }

  /* Service Requests */

  findServiceRequests({ organizationId }) {
    return this.api
      .get(`/${organizationId}/service-requests`)
      .then((res) => res.data);
  }
  dispatchServiceRequest({
    organizationId,
    serviceRequestId,
    practitionersIds,
  }) {
    return this.api
      .post(
        `/${organizationId}/service-requests/${serviceRequestId}/dispatch`,
        { practitionersIds }
      )
      .then((res) => res.data);
  }

  /* Pending Organizations */
  acceptPendingOrg(organizationId) {
    return this.api
      .post(`/${organizationId}/accept-pending`)
      .then((res) => res.data);
  }

  declinePendingOrg(organizationId) {
    return this.api
      .post(`/${organizationId}/decline-pending`)
      .then((res) => res.data);
  }

  /* Patient List Tranfer */

  public transferPatient({
    id,
    patientUserId,
  }: {
    id: string;
    patientUserId: string;
  }) {
    return this.api
      .post(`/${id}/transfer-patient/${patientUserId}`)
      .then((res) => res.data);
  }
}
